<template>

	<!-- 상세본문 -->
	<div class="content board-detail" v-if="boardVO.idx > 0">

		<div class="board_view">
			<div class="view_head">
				<em class="cate">
					<span class="notice_cate mr-2" v-if="boardVO.isNotice">공지</span>
					<span v-if="boardVO.cateVO != null">{{ boardVO.cateVO.codeName }}</span>
				</em>
				<div style="border: 0; display: flex; align-items: center; justify-content: space-between" class="support_list">
					<h2 class="tit">
						<span class="mr-2" v-if="boardInfoVO.isStatus && !$options.filters.isEmpty(boardVO.statusCode)"
							:class="{ 'end' : (boardVO.statusName === '완료'), 'ing' : (boardVO.statusName === '확인'), 'req' : !(boardVO.statusName === '완료' || boardVO.statusName === '확인') }">
							<span>{{ boardVO.statusName }}</span>
						</span>
						{{ boardVO.title }}</h2>
				</div>
				
				
				<div class="info">
					<span class="name" v-if="!boardInfoVO.isAnonymous">{{ boardVO.writerDec }}</span>
					<span class="date">{{ boardVO.createDate | datetimeFilter }}</span>
					<span class="like">{{ boardVO.likeCount | currency }}</span>
					<span class="view">{{ boardVO.views | currency }}</span>
				</div>
			</div>
			<div class="view_cont">

				<div class="cont_wrap">
<!--					<html-open :html-code="boardVO.contentHtml"></html-open>-->
					<summernote-frame :target-id="'contentHtml-' + boardVO.idx " ref="summernote" mode="view" :html="boardVO.contentHtml"></summernote-frame>
				</div>

				<ul class="attach_wrap" v-if="boardInfoVO.isFile && boardVO.attachList.length > 0">
					<li v-for="(item, index) in boardVO.attachList">
						<a @click="doDownload(item.fidx)">{{ item.filename }}</a>
					</li>
				</ul>

			</div>

			<div class="view_footer">
				<div class="left_box">
					<button type="button" class="btn btn_like" :class="{ 'active': (likeVO.isMine) }" @click="setLike"><span>좋아요 {{ boardVO.likeCount | currency }}</span></button>
					<button type="button" class="btn btn_comment" v-show="boardInfoVO.isComment" onclick="location.href='#commentList'"><span>댓글 {{ boardVO.commentCount | currency }}</span></button>
				</div>
				<div class="right_box">
					<button type="button" class="btn btn_report" @click="doCaution"><span>신고</span></button>
					<button type="button" class="btn btn_edit" v-if="isLogin() && isMine(boardVO.writerKey)" @click="goForm">수정</button>
					<button type="button" class="btn btn_delete" v-if="isLogin() && isMine(boardVO.writerKey)" @click="goDelete">삭제</button>
				</div>
			</div>

		</div>

		<comment-default :bidx="boardVO.idx" v-show="boardInfoVO.isComment"></comment-default>

		<div class="btn_wrap" style="text-align: center; margin-top: 30px;">
			<button type="button" class="btn btn-lg btn-dark btn_learn" @click="goList">목록으로</button>
		</div>

	</div>

</template>

<script>


import CommentDefault from "@/cs1/components/boards/comments/commentDefault";
import APIs from "@/commons/APIs";
import HWAPP from "@/commons/mixins/hwapp.mixin";
import HtmlOpen from "@/components/display/htmlOpen";

import SummernoteFrame from "@/components/display/summernoteFrame";
import('summernote/dist/summernote.css')
import('summernote/dist/summernote-bs4.css')

export default {
	name: "detailDefault",
	components: {SummernoteFrame, HtmlOpen, CommentDefault},
	props: {
		boardInfoVO: Object,
		boardVO: Object,
	},
	mixins: [HWAPP],
	data() {

		return {
			// idx: this.webUtils.getParameterInt("idx"),
			idx: this.$route.query.idx,

			commentVO: new this.CommentVO( this.getSessionProc() ),
			commentList: [],

			likeVO: new this.LikeVO( this ),
		}
	},
	created() {

		// alert( this.APIs.BASE_URL )

	},
	mounted() {

		/*if ( this.idx > 0 ) {
			this.getCommentList();
		}*/
		//this.$nextTick(() => this.getLike(this.boardVO.idx, this.getLoginId()) );
	},
	updated() {

	},
	methods: {

		goList() {
			// history.back();
			this.$emit("goList");
		},


		goComment () {
			this.webUtils.scrollTo( ".detail-comment" )
		},

		goForm(e) {
			this.$emit("goForm", e, this.boardVO.idx);
			/*var queryStr = "?mode=form&idx=" + this.boardVO.idx
			location.href = location.pathname + queryStr*/
		},

		goDelete(e) {

			const self = this
			this.swalUtils.fire("삭제 하시겠습니까?", "첨부된 파일과 댓글 모두 삭제가 됩니다. 계속하시겠습니까?", "error", true )
			.then((result) => {
				if ( result.isConfirmed ) {

					self.axiosCaller.delete( this, this.APIs.BOARDS + "/deleteOne/" + self.boardVO.idx, {
						idx: self.boardVO.idx,
						userId: self.getLoginId(),
					}, (res) => {
						const result = res.data;
						if (result.status === "ok") {
							history.back()
						} else {
							console.log( result.msg )
						}
					})

				}
			})
			/*var queryStr = "?mode=form&idx=" + this.boardVO.idx
			location.href = location.pathname + queryStr*/
		},


		/**
		 * 좋아요 수 + 내 좋아요 여부 조회
		 */
		getLike ( bidx, userId ) {

			if ( bidx > 0 ) {

				this.axiosCaller.get(this, this.APIs.BOARD_LIKE + "/" + bidx + "/" + userId, {}, (res) => {
					const result = res.data
					if ( result.status === "ok" ) {
						this.boardVO.likeCount = result.likeCount
						this.likeVO = result
					}
				})
			}
		},


		setLike () {

			const self = this
			if ( !this.likeVO.isMine ) {    // 추가

				this.axiosCaller.put( this, this.APIs.BOARD_LIKE + "/" + self.boardVO.idx + "/" + self.getLoginId(), {}, (res) => {
					const result = res.data
					if ( result.status === "ok" ) {
						this.boardVO.likeCount = result.likeCount
						this.likeVO.isMine = result.isMine
					}
				})

			} else {    // 삭제

				this.axiosCaller.delete( this, this.APIs.BOARD_LIKE + "/" + self.boardVO.idx + "/" + self.getLoginId(), {},(res) => {
					const result = res.data
					if ( result.status === "ok" ) {
						this.boardVO.likeCount = result.likeCount
						this.likeVO.isMine = result.isMine
					}
				})

			}

		},



		doCaution () {

			const self = this
			self.swalUtils.fire("게시물 신고", "해당 게시물을 신고합니다.", "warning", true)
			.then( (result) => {

				if ( result.isConfirmed ) {
					const url = self.APIs.BOARD_CAUTION + "/" + self.boardVO.idx + "/" + self.getLoginId()
					self.axiosCaller.put(self, url, {}, (res) => {
						const result = res.data;
						if ( result.status === "ok" ) {

							self.swalUtils.gritter("게시물 신고", "신고되었습니다.", "info", 2000 );
							return

						} else if ( result.status === "fail" ) {
							self.swalUtils.gritter("게시물 신고", "해당게시물은 이미 신고한 계정입니다.", "info", 2000 );
							return
						}
					})
				}

			});

		},



		doDownload(fidx) {
			if (this.appDevice() === "IOS") {
				webkit.messageHandlers.iOSFileDownload.postMessage(APIs.BOARD_FILES_DOWN + '/' + fidx)
				return;
			}
			location.href = APIs.BOARD_FILES_DOWN + '/' + fidx
		}



	},
	watch: {
		'boardVO': function(newVal, oldVal) {
			/*console.log("newVal ::::: " + newVal.idx)
			console.log("oldVal ::::: " + oldVal.idx)*/
			if ( newVal.idx !== undefined && newVal.idx > 0 ) {
				//this.getCommentList();
				this.$nextTick(() => this.getLike(this.boardVO.idx, this.getLoginId()) );
			}
		},
	}
}
</script>

<style scoped>
</style>
